module.exports = __webpack_public_path__ + "img/logo.192c41a4.png";